import QuestionPreview from "pages/QuestionPage/questionPreview/QuestionPreview/QuestionPreview";

export default QuestionPreview;
